import {createSlice} from '@reduxjs/toolkit'

import {RootState} from '~/stores'

export enum LOGIN_STATUS {
  LOGIN = 1,
  NOT_LOGIN = 0,
}

type DeviceInfo = {
  h_app: string
  h_did: string
  h_m?: number
  token: string
  h_ts: number
  h_ch: string
  h_model: string
  h_dt?: number
  h_av?: string
  // 其他必须
  ua: string
  statusBar: number
  isLogin?: LOGIN_STATUS
  isreg: number
  theme: 'light' | 'dark' | ''
  device_fingerprint?: string
}

const initialState: DeviceInfo = {
  h_app: 'pixel_muse',
  h_ts: Date.now(),
  h_av: '',
  h_ch: '',
  h_did: '',
  h_model: '',
  token: '',
  ua: '',
  statusBar: 0,
  isreg: null,
  theme: 'light',
  device_fingerprint: '',
}

export const deviceInfoSlice = createSlice({
  name: 'deviceInfo',
  initialState,
  reducers: {
    set(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const selectDeviceInfo = (state: RootState) => state.deviceInfo
// 用户登录状态
export const selectIsLogin = (state: RootState) => state.deviceInfo?.isLogin

export default deviceInfoSlice.reducer
